import {
  Component,
  OnInit,
  Input,
  OnChanges,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewChild,
  ElementRef,
  AfterViewInit, AfterViewChecked, ViewRef, HostListener, OnDestroy
} from '@angular/core';
import _ from 'lodash';
import {
  CanvasActionConditionModel,
  CanvasRuleactionModel,
  CanvasTreeModel
} from '../canvas-form-builder/canvastree.model';
import {jsPlumb} from 'jsplumb';
import {RuleModel} from '../../../../../../projects/api/src/rule/rule.model';
import {RuleactionModel} from '../../../../../../projects/api/src/ruleaction/ruleaction.model';
import {StandardFormMetaInfo} from '../standard-form-builder/standard-form-meta-info.model';
import {showTooltip} from '../standard-form-builder/standard-form.helpers';
import {DeviceparamModel} from '../../../../../../projects/api/src/deviceparam/deviceparam.model';
import {CalcparamModel} from '../../../../../../projects/api/src/calcparam/calcparam.model';
import {TranslateService} from '@ngx-translate/core';
import Panzoom from '@panzoom/panzoom';
import { RuleoverviewStandardFormMeta } from '../../../../../../projects/admin/modules/typicalconfig/rule-overview-page/ruleoverview-standard-form-meta';

@Component({
  selector: 'svg-node-component',
  templateUrl: './svg-node.component.html',
  styleUrls: ['./svg-node.component.scss']
})
export class SvgNodeComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit, AfterViewChecked {
  @Input() updatecount;
  @Input() rule;
  @Input() actionconditions;
  @Input() ruleactions;
  @Input() isTooltip;
  @Input() calcparams: CalcparamModel[];
  @Input() deviceparams: DeviceparamModel[];
  @Output() onSelected = new EventEmitter<any>();
  @Output() plusCondition = new EventEmitter<Object>();
  @Output() onDelete = new EventEmitter<Object>();
  @ViewChild('panzoom', {static: true}) scene: ElementRef;
  @ViewChild('btnZoomIn', {static: true}) btnZoomIn: ElementRef;
  @ViewChild('btnZoomOut', {static: true}) btnZoomOut: ElementRef;
  @ViewChild('btnZoomReset', {static: true}) btnZoomReset: ElementRef;
  @HostListener('window:resize', ['$event'])
  onResize = _.throttle((event) => {
    this.makeCanvasTree();
  }, 100);

  panZoomController;
  mode = 'EditDescription;EditRootCondition;';//EditRootActions';/*EditDescription, EditRootActions, EditConditions, EditCondition, EditAction, EditActions*/
  actioncondition: RuleModel;
  ruleaction: RuleactionModel;
  canvasTree: CanvasTreeModel[] = [];

  allRules: any[] = [];
  jsPlumbInstance;

  nodes = [];
  items = [1, 2, 3, 4];
  connections = [];
  title = ' Angular jsPlumb Integration';
  jsFireFlag = false;
  activeTooltips = [];


  public formMeta: StandardFormMetaInfo[] = RuleoverviewStandardFormMeta;

  public readonly conditionsGroup = ['condition'];
  index = 0;
  public processedConditions = [];
  MAX_LEVEL = 99;
  levels = [];
  isJsPlumb = true;
  updatetime = 0;
  isRendered = false;
  el: any;
  doc: any;
  parent: any;
  nodeSelectedId: number;
  protected readonly showTooltip = showTooltip;
  private setValueMethod = true;
  CONDITION = 'Condition';

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef) {
    this.CONDITION = this.translate.instant('Condition');
  }

  ngOnInit() {
    setTimeout(() => {
      this.makeCanvasTree();
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      this.makeCanvasTree();
    }, 100);
    /*
        for (let propName in changes) {
          // when your @Input value is changed
          if(propName === "yourInputName"){
            // update the component here
          }
        }
    */
  }

  ngAfterViewInit() {
    return;
  }

  ngAfterViewChecked() {
    if (!this.isRendered && this.scene?.nativeElement && this.scene?.nativeElement.ownerDocument) {
      this.panzoomInit();
    }
  }

  detectChanges() {
    // Programmatically run change detection to fix issue in Safari
    setTimeout(() => {
      if (this.cdr !== null &&
        this.cdr !== undefined &&
        !(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }

    }, 250);
  }

  log(value) {
    console.log(value);
  }

  panzoomInit() {
    if (this.panZoomController) {
      this.panZoomController.destroy;
    }
    const el = this.scene.nativeElement;
    const doc = el.ownerDocument;
    const parent = el.parentNode;
    let containerWidth = parent.offsetWidth;
    let containerHeight = parent.offsetHeight;
    let schemeWidth = el.offsetWidth;
    let schemeHeight = el.offsetHeight;
    let initScale: number;

    if (doc && parent && doc.nodeType === 9 && parent.nodeType === 1 && doc.documentElement.contains(parent) && schemeWidth && schemeHeight) {
      this.isRendered = true;
      let deltaWidth = containerWidth - schemeWidth;
      let deltaHeight = containerHeight - schemeHeight;
      initScale = (-deltaWidth > -deltaHeight) ? containerWidth / schemeWidth : containerHeight / schemeHeight;

      this.panZoomController = Panzoom(el, {
        // maxScale: 5,
        canvas: true,
        startScale: initScale,
        startX: 0,
        startY: 0, // -((schemeHeight / 2) / initScale - schemeHeight / 2),
        // minScale: 0.1,
        // maxScale: 5,
        animate: false,
        // contain: "outside",
        origin: 'center top'
      });
      // this.panZoomController.setStyle('height', `${containerHeight}px`);
      // this.panZoomController.pan(0, -((schemeHeight / 2) / initScale - schemeHeight / 2));


      el.parentElement.addEventListener('wheel', (event) => {

        let currentScale = this.panZoomController.getScale();
        // this.panZoomController.setStyle('transform-origin', 'center');
        // this.panZoomController.setOptions({ origin: 'center' });
        this.panZoomController.zoomWithWheel(event, {
          // canvas: true,
          // startScale: initScale,
          // startX: 0,
          // startY: -((schemeHeight / 2) / initScale - schemeHeight / 2),
          // origin: 'center center',
          step: initScale / 20,
          // origin: '50% 0',
          focal: { x: event.x / currentScale , y: event.y / currentScale } //schemeWidth / (currentScale * 2), y: schemeHeight / (currentScale * 2)
          // focal: {x: event.target.clientX, y: event.target.ClientHeight / 2 } //schemeWidth / (currentScale * 2), y: schemeHeight / (currentScale * 2)
        });
      });

      this.btnZoomIn.nativeElement.addEventListener('click', this.panZoomController.zoomIn);
      // this.btnZoomIn.nativeElement.addEventListener('click', (event) => {
      //   // let currentScale = this.panZoomController.getScale();
      //   // console.log('event: ', event);
      //   console.log('pan: ', this.panZoomController.getPan());
      //   console.log('getScale: ', this.panZoomController.getScale());
      //   // let nodesElHeight = schemeHeight;
      //   this.panZoomController.zoomIn({
      //     step: 0.1,
      //     animate: false,
      //     focal: { x: 0 , y: -(schemeHeight * this.panZoomController.getScale()) / 2 } //schemeWidth / (currentScale * 2), y: schemeHeight / (currentScale * 2)
      //   })
      // });
      this.btnZoomOut.nativeElement.addEventListener('click', this.panZoomController.zoomOut);
      // this.btnZoomOut.nativeElement.addEventListener('click', (event) => {
      //   // let currentScale = this.panZoomController.getScale();
      //   // console.log('event: ', event);
      //   console.log('pan: ', this.panZoomController.getPan());
      //   console.log('getScale: ', this.panZoomController.getScale());
      //   // let nodesElHeight = schemeHeight;
      //   this.panZoomController.zoomOut({
      //     step: 0.1,
      //     animate: false,
      //     origin: '50% 50%',
      //     focal: { x: 0 , y: -(schemeHeight * this.panZoomController.getScale()) / 2 } //schemeWidth / (currentScale * 2), y: schemeHeight / (currentScale * 2)
      //   })
      // });
      this.btnZoomReset.nativeElement.addEventListener('click', this.panZoomController.reset);

      this.detectChanges();
    }
  }

  ngOnDestroy() {
    // window.onmousewheel = function() {};
    // if (this.jsPlumbInstance && this.jsFireFlag) {
    //   this.deleteJsConnections();
    //   this.jsFireFlag = false;
    // }

    if (this.panZoomController) {
      this.scene.nativeElement.removeEventListener('wheel', this.panZoomController.zoomWithWheel, false);
      this.scene.nativeElement.removeEventListener('click', this.panZoomController.zoomIn, false);
      this.scene.nativeElement.removeEventListener('click', this.panZoomController.zoomOut, false);
      this.scene.nativeElement.removeEventListener('click', this.panZoomController.reset, false);
    }
    //setTimeout(()=> {this.makeCanvasTree()}, 100);
  }

  filterByLevel(nodes: any[], level: number) {
    return nodes.filter(node => node.level + '' === level + '');
  }

  onSelected2(event, cmd?) {
    if (event && event.node) {
      event = event.node;
    }
    this.onSelected.emit(event);
    if (event.type === 'action' || event.type === 'root') {
      this.jsPlumbInstance.getAllConnections().forEach(connector => {
        connector.removeClass('jtk-connector_active', true);
      });
      this.nodeSelectedId = event.id;
    } else if (event.type === 'condition') {
      this.nodeSelectedId = undefined;
    }

  }

  makeCanvasTree() {
    this.levels = [];
    if (this.jsPlumbInstance && this.jsFireFlag) {
      this.deleteJsConnections();
      this.jsFireFlag = false;
    }
    this.canvasTree = [];
    this.processedConditions = [];
    let canvasTree: CanvasTreeModel = {};
    canvasTree.id = this.rule.id;
    canvasTree.name = this.rule.rulename;
    canvasTree.level = 0;
    canvasTree.type = 'condition';
    const actions0 = this.makeRuleActionsTree(0, 0, 0, 50);

    let rules = [];
    canvasTree.rules = this.makeCanvasRules(actions0, 1);
    this.allRules = [];
    this.nodes = [];
    this.connections = [];
    this.addJsNode({class: 'box-05', id: this.rule.id + '', title: this.rule.rulename, level: 0});
    this.processIdenticalRules(canvasTree.rules);
    this.addJsNodes(canvasTree.rules, 1);
    this.adjustNodes();
    this.addJsConnections();
    // this.removeDublicateConnections();
    if (!this.jsPlumbInstance) {
      this.jsPlumbInstance = jsPlumb.getInstance();
    }
    setTimeout(() => {
      this.makeJsConnections();
      this.panzoomInit();
    }, 100);
  }

  removeDublicateConnections() {
    if (this.connections && this.connections.length > 0) {
      let connections = [];
      this.connections.forEach(con => {
        const c1 = connections.filter(c => c.source === con.source && c.target === con.target);
        if (c1.length === 0) {
          connections.push(con);
        }
      });
      this.connections = connections;
    }
  }

  adjustNodes() {
    if (this.nodes && this.nodes.length > 0) {
      for (let lv = 0; lv < this.MAX_LEVEL; lv++) {
        const nodes = this.nodes.filter(node => node.level === lv);
        if (nodes && nodes.length > 0) {
          this.levels.push(lv);
          const number = nodes.length;
          const delta = Math.round(10 / (number + 1));
          let inx = delta;
          nodes.forEach(n => {
            n.class = 'box-' + lv + inx;
            inx += delta;
          });
        }
      }
    }
  }

  addJsNodes(rules: any[], level: number) {
    if (!rules || rules.length === 0) {return;}
    const levelRules = rules.filter(rule => rule.level === level && !rule.invisible);
    const number = levelRules.length;
    const delta = Math.round(10 / (number + 1));
    if (levelRules.length > 0) {
      let inx = delta;
      levelRules.forEach(rule => {
        const found = this.nodes.filter(node => node.id === rule.id);
        if (found.length > 0) {return;}

        this.addJsNode({
          class: 'box-' + level + inx,
          id: rule.id,
          title: rule.name,
          action: true,
          value: rule.label,
          level: level
        });
        inx += delta;
        if (rule.root) {
          // this.connections.push({source: this.rule.id + '', target: rule.id + '', title: '?', id: this.rule.id, condition: this.rule.condition, delay: this.rule.delaytime, type: 'root'});
          this.connections.push({
            source: this.rule.id + '',
            target: rule.id + '',
            title: this.rule.id + '',
            id: this.rule.id,
            condition: this.rule.condition,
            delay: this.rule.delaytime,
            type: 'root'
          });
        }
        if (rule.conditions) {
          rule.conditions.forEach(condition => {
            if (condition.rules) {
              this.addJsNodes(condition.rules, level + 2);
            }
          });
        }
      });
    }
  }

  addJsNode(node) {
    this.nodes.push({
      class: node.class,
      id: node.id,
      title: node.title,
      action: node?.action,
      value: node?.value,
      type: 'action',
      level: node?.level
    });
  }

  addJsConnections() {
    if (!this.actionconditions || this.actionconditions.length === 0) {return;}
    this.actionconditions.forEach(condition => {
      if (condition && condition.ownerAction?.id && condition.conditionAction?.id) {
        const source = this.nodes.filter(node => node.id === condition.ownerAction.id)[0];
        const target = this.nodes.filter(node => node.id === condition.conditionAction.id)[0];
        let direction = 1;
        if (source && target) {
          if (source.level > target.level) {
            direction = 0;
          }
          this.connections.push({
            id: condition.id,
            source: condition.ownerAction.id + '',
            target: condition.conditionAction.id + '',
            title: condition.id + '',
            type: 'condition',
            direction: direction,
            delay: condition.delaySec,
            condition: condition.condition
          });
        }
      }
    });
  }

  deleteJsConnections() {
    this.jsPlumbInstance.deleteEveryEndpoint();
  }

  makeJsConnections() {

    this.jsFireFlag = true;
    this.deleteJsConnections();
    if (this.connections) {
      if (!this.jsPlumbInstance) {
        this.jsPlumbInstance = jsPlumb.getInstance();
      }
      this.connections.forEach(connection => {
          const delay = connection.delay * 60;
        const dir = (connection.direction !== undefined && connection.direction === 0) ? false : true;
        const label = connection.delay > 0 ? `<div class="connection__label" title="${connection.condition}"><div>${this.CONDITION}</div><div><i class="fa fa-clock-o fa-xs u-margin-right-tiny" title="${delay} sec"></i> ${delay} sec</div></div>` : `<div class="connection__label"><div title="${connection.condition}">${this.CONDITION}</div></div>`;
        this.jsPlumbMakeConnection(connection.title, connection.source, connection.target, label, dir);
      });
      var th = this;
      this.jsPlumbInstance.bind('click', function(connection, originalEvent) {
        this.getAllConnections().forEach(connector => {
          connector.removeClass('jtk-connector_active', true);
        });
        connection.addClass('jtk-connector_active');
        const sourceId = Number.parseInt(connection.sourceId);
        const targetId = Number.parseInt(connection.targetId);
        if (!th.isTooltip) {
          return;
        }
        if (sourceId === th.rule.id) {
          th.onSelected2({id: sourceId, type: 'root'});
        } else {
          const conn = th.actionconditions.filter(con => con.ownerAction?.id === sourceId && con.conditionAction.id === targetId);
          this.actioncondition = conn[0];
          th.onSelected2({id: this.actioncondition.id, type: 'condition'});
        }
      });
      // this.jsPlumbInstance.bind("contextmenu", function(connection, originalEvent){
      //   const time = new Date().getTime();
      //   if (time - th.updatetime < 500) return;
      //   th.updatetime = time;
      //   const sourceId = Number.parseInt(connection.sourceId);
      //   const targetId = Number.parseInt(connection.targetId);
      //   //connection.getOverlay().
      //   connection.removeOverlay('css' + sourceId + '_' +targetId);
      //   connection.removeOverlay('connLabel' + sourceId + '_' +targetId);
      //   if (sourceId === th.rule.id) {
      //     th.rule['overlay'] = th.rule['overlay'] ? false : true;
      //     const label = th.rule['overlay'] ?  th.rule.condition : '?';
      //     connection.addOverlay(["Label", { label: label, location:0.5, id: 'connLabel' + sourceId + '_' +targetId} ]);
      //   } else {
      //     const conn = th.actionconditions.filter(con => con.ownerAction?.id ===  sourceId && con.conditionAction.id === targetId);
      //     conn[0]['overlay'] = conn[0]['overlay'] ? false : true;
      //     const label = conn[0]['overlay'] ? conn[0].condition : conn[0].id + '';
      //     connection.addOverlay(["Label", { label: label, location:0.5, id: 'connLabel' + sourceId + '_' +targetId} ]);
      //   }
      // });
    }
  }

  jsPlumbMakeConnection(id: string, source: string, target: string, label: string, direction: boolean) {
    if (!this.jsPlumbInstance) {
      this.jsPlumbInstance = jsPlumb.getInstance();
    }


    if (source === target) {
      const ep1 = this.jsPlumbInstance.addEndpoint(source, {
        anchors: ['Right', 'Left'],
        paintStyle: {fill: '#458', stroke: '#480'},
        endpoint: ['Dot', {radius: 5}
        ]
      });

      const ep2 = this.jsPlumbInstance.addEndpoint(target, {
        anchors: ['Right', 'Left'],
        paintStyle: {fill: '#456', stroke: '#480'},
        endpoint: ['Dot', {radius: 4}]
      });
      this.jsPlumbInstance.connect({
        source: ep1,
        target: ep2,
        anchors: ['Right', 'Left'],
        connector: 'Bezier',
        detachable: false,
        paintStyle: {fill: 'transparent', stroke: 'var(--colorTextMuted)', strokeWidth: 8},
        overlays: [
          ['Arrow', {location: 1}],
          ['Label', {
            label: label,
            location: 0.5,
            id: 'css' + source + '_' + target,
            cssClass: 'connectingConnectorLabel'
          }]
        ]
      });
      this.jsPlumbInstance.connect({
        source: ep1,
        target: ep2,
        anchors: ['Right', 'Left'],
        connector: 'Bezier',
        detachable: false,
        paintStyle: {fill: 'transparent', stroke: 'var(--colorIcon)', strokeWidth: 8},
        overlays: [
          ['Arrow', {location: 1}],
          ['Label', {
            label: label,
            location: 0.5,
            id: 'css' + source + '_' + target,
            cssClass: 'connectingConnectorLabel'
          }]
        ]
      });

    } else {
      const ep1 = this.jsPlumbInstance.addEndpoint(source, {
        anchor: direction ? 'Continuous' : 'Left',
        paintStyle: {fill: 'var(--colorIcon)', stroke: 'var(--colorIcon)'},
        endpoint: ['Dot', {radius: 5}
        ]
      });

      const ep2 = this.jsPlumbInstance.addEndpoint(target, {
        anchor: direction ? 'Top' : 'Left',
        paintStyle: {fill: '#456', stroke: '#480'},
        endpoint: ['Rectangle', {width: 5, height: 4}]
      });
      this.jsPlumbInstance.connect({
        source: ep1,
        target: ep2,
        connector: direction ? 'Straight' : 'Bezier',
        detachable: false,
        cssClass: 'animated-edge',
        paintStyle: {fill: 'transparent', stroke: 'var(--colorTextMuted)', strokeWidth: 8},
        overlays: [
          ['Arrow', {location: 1}],
          ['Label', {
            label: label,
            location: 0.5,
            id: 'css' + source + '_' + target,
            cssClass: 'connectingConnectorLabel'
          }]
        ]
      });


    }
    //label = direction ? 'true' : 'false';
  }

  processIdenticalRules(rules: any) {
    if (!rules) {return;}
    rules.forEach(rule => {

      if (rule.type === 'rule') {
        const founds = this.allRules.filter(_r => _r.id === rule.id && _r.type === 'rule');
        if (founds.length === 0) {
          if (rule.conditions) {
            this.proccessIdenticalConditions(rule.conditions);
          }
          const founds2 = this.allRules.filter(_r => _r.id === rule.id && _r.type === 'rule');
          this.allRules.push({
            id: rule.id,
            level: rule.level,
            type: 'rule',
            conditions: rule.conditions,
            invisible: rule.invisible
          });
        } else {
          founds.forEach(found => {
            if (found.level > rule.level) {
              rule.invisible = true;
              delete rule.conditions;
            } else {
              found.invisible = true;
              if (found.conditions) {
                delete found.conditions;
              }

              if (rule.conditions) {
                this.proccessIdenticalConditions(rule.conditions);
              }
            }
          });
        }
      }
      ;
    });

  }

  proccessIdenticalConditions(conditions: any[]) {
    if (conditions) {
      conditions.forEach(cond => {
        if (cond.rules) {
          this.processIdenticalRules(cond.rules);
        }
      });
    }
  }

  makeCanvasRules(actions: any[], level: number): CanvasRuleactionModel[] {
    let actions0: CanvasRuleactionModel[] = [];
    if (!actions || actions.length == 0) {return [];}

    actions.forEach(act => {
      let rule: CanvasRuleactionModel = {};
      rule.root = act.root;
      rule.id = act.id;
      rule.name = act.deviceparam.paramname;
      rule.level = level;
      rule.type = 'rule';
      rule.label = typeof act.action === 'string' ? act.action : act.action?.label;
      const conditions = this.makeCanvasConditions(act.actionconditions, (rule.level + 1));
      rule.conditions = conditions;
      actions0.push(rule);
    });
    return actions0;
  }

  makeCanvasConditions(conditions: any[], level: number): CanvasActionConditionModel[] {
    let conditions0: CanvasActionConditionModel[] = [];
    if (!conditions || conditions.length == 0) {return [];}

    let i = 0;
    const dY = 25;
    let opacity = 0.8;
    conditions.forEach(cond => {
      const processed = this.processedConditions.filter(c => c.id === cond.id);
      if (processed.length > 0) {return [];}
      this.processedConditions.push(cond);

      let c: CanvasActionConditionModel = {};
      c.id = cond.id;
      c.level = level;
      c.type = 'condition';
      c.name = cond.condition;
      if (cond.ownerAction && cond.conditionAction && (cond.ownerAction.id === cond.conditionAction.id)) {
      } else {
        const rules = this.makeCanvasRules(cond.actionrules, (level + 1));
        c.rules = rules;
      }
      conditions0.push(c);

      i++;
    });
    return conditions0;
  }

  makeRuleActionsTree(level?: number, offsetX?: number, offsetY?: number, delta?: number): any[] {
    const allConditions = _.clone(this.actionconditions);
    const allActions = _.clone(this.ruleactions);
    let actions0: any[] = [];
    let actions2: any[] = [];
    if (!allActions) {return;}

    allActions.forEach(act => {
      const ownerconditions = allConditions.filter(cond => cond.ownerAction.id === act.id);
      if (ownerconditions.length === 0 && act.root === true) {
        actions0.push(act);
      } else if (ownerconditions.length > 0 && act.root === true) {
        act['actionconditions'] = ownerconditions;
        actions0.push(act);
        ownerconditions.forEach(cond => {
          let act = allActions.filter(act => act.id === cond.conditionAction.id);
          cond['actionrules'] = act;
          actions2.push(act);
        });
      } else if (ownerconditions.length > 0 && act.root === false) {
        act['actionconditions'] = ownerconditions;
        //actions0.push(act);
        ownerconditions.forEach(cond => {
          let act0 = allActions.filter(act => act.id === cond.ownerAction.id);
          //cond['actionrules'] = act0;
          actions2.push(act0);
          let act2 = allActions.filter(act => act.id === cond.conditionAction.id);
          //cond['actionrules'] = [...act0[0], ...act[0]];
          cond['actionrules'] = act2;
          actions2.push(act);
          actions0.push(act);
        });
      } else {
        actions0.push(act);
      }
    });

    //this.makeLevelTree(1, actions2);

    return actions0;

  }

  toggleTooltip(tooltip, data: object, title: string) {
    // const jplumbContainer = this.scene.nativeElement.parent as HTMLElement;

    if (tooltip.isOpen()) {
      tooltip.close();
    } else {
      for (let i = 0; i < this.activeTooltips.length; i++) {
        this.activeTooltips[i].close();
      }
      this.activeTooltips.push(tooltip);
      tooltip.open({tooltip, data, title});
      // jplumbContainer.addEventListener('panzoomstart', function _panzoomStartListener() {
      //   tooltip.close();
      //   jplumbContainer.removeEventListener('panzoomstart', _panzoomStartListener, true);
      // }, true);
    }
  }
}
